import React from 'react'

import Button from 'components/molecules/Button'
import { useMandatoryDlCheck } from 'hooks/use-mandatory-dl-check'

const DriverLicenseCheckPanel: React.FC = () => {
  const { isVisible, isValid, isInvalid, isLoading, setDriverDocValid } = useMandatoryDlCheck()

  if (!isVisible) return null

  return (
    <div className="d-flex" style={{ marginTop: '8px', gap: '4px' }}>
      <Button
        className="p-1"
        style={{ flex: 1 }}
        disabled={isInvalid || isLoading}
        onClick={() => setDriverDocValid(false)}
        content="Недействительно"
      />
      <Button className="p-1" style={{ flex: 1 }} disabled={isValid || isLoading} onClick={() => setDriverDocValid(true)} content="Действительно" />
    </div>
  )
}

export default DriverLicenseCheckPanel
